<template>
    <div>
    <v-dialog
        v-model="dialogSale"
        width="1300"
        persistent
        scrollable
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                small
                color="success"
                class="text-capitalize"
                v-bind="attrs"
                v-on="on"
            >{{ $t('Nueva venta') }}</v-btn>
        </template>

        <v-form @submit.prevent="onSubmit" lazy-validation ref="formSale">
            <v-card :loading="loading" :disabled="loading">
                <v-card-title class="text-h5 grey lighten-2">
                    {{ $t('Nueva venta')}}
                </v-card-title>

                <v-card-text class="pt-4">
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                            <v-switch
                                v-model="form.credit"
                                :false-value="1"
                                :true-value="0"
                                :label="form.credit ? $t('Crédito') : $t('Contado')"
                            ></v-switch>
                            <v-text-field
                                :label="$t('Días de crédito *')"
                                dense
                                outlined
                                v-model="form.days"
                                :rules="[rules.required]"
                                v-if="form.credit"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-checkbox
                                :label="$t('Venta rápida')"
                                :false-value="0"
                                :true-value="1"
                                v-model="form.fast"
                            ></v-checkbox>
                            <v-text-field
                                :label="$t('Nombre cliente *')"
                                dense
                                outlined
                                v-model="form.client"
                                :rules="[rules.required]"
                                v-if="!form.fast"
                            ></v-text-field>
                            <v-text-field
                                :label="$t('NIT / CI *')"
                                dense
                                outlined
                                v-model="form.nit"
                                :rules="[rules.required]"
                                v-if="!form.fast"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-checkbox
                                :label="$t('Enviar recibo vía celular')"
                                :false-value="0"
                                :true-value="1"
                                v-model="form.invoice"
                            ></v-checkbox>
                            <v-text-field
                                :label="$t('Número de celular *')"
                                dense
                                outlined
                                type="number"
                                v-model="form.phone"
                                :rules="[rules.required]"
                                v-if="form.invoice"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <br>
                            <v-select
                                :label="$t('Tipo de pago')"
                                outlined
                                dense
                                :items="[$t('Efectivo'), $t('Qr'), $t('Tarjeta'), $t('Plataformas de pedido')]"
                                v-model="form.payment"
                                :rules="[rules.required]"
                            ></v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="5">
                            <br>

                             <v-text-field
                                :label="$t('Comentario extra')"
                                dense
                                outlined
                                type="text"
                                v-model="form.comment_order"
                            ></v-text-field>

                            <v-text-field
                                v-if="typeStore == 'gastronomic'"
                                :label="$t('Número de mesa')"
                                dense
                                outlined
                                type="number"
                                min="0"
                                step="1"
                                v-model="form.table_number"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="7" v-if="isCashPayment">
                            <v-card outlined class="pa-3 elevation-1">
                                <v-row dense align="center">
                                    <v-col cols="12" sm="4">
                                        <v-text-field
                                            :label="$t('Total a pagar')"
                                            dense
                                            outlined
                                            hide-details
                                            readonly
                                            :value="`${money} ${netAmountDueFormatted}`"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field
                                            :label="$t('Paga el cliente')"
                                            dense
                                            outlined
                                            hide-details
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            v-model="cashReceived"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field
                                            :label="$t('Cambio')"
                                            dense
                                            outlined
                                            hide-details
                                            readonly
                                            :color="cashChange > 0 ? 'error' : undefined"
                                            class="cash-change-field"
                                            :class="{ 'cash-change-field--active': cashChange > 0 }"
                                            :value="cashChangeFormatted"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!-- add barcode -->
                    <template>
                        <div class="text-center pa-4">
                            <!-- <v-btn @click="dialog = true">
                                Open Dialog
                            </v-btn> -->

                            <v-dialog
                                v-model="dialog"
                                max-width="500"
                                persistent
                            >
                                <v-card>
                                    <v-card-title class="text-h5 grey lighten-2">
                                        {{ $t('Escanear Código de barras.') }}
                                    </v-card-title>

                                    <barcode
                                        @result="onScan"
                                        ref="barcodeRef"
                                        container="reader_sale"
                                    ></barcode>

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="primary"
                                        text
                                        @click="stopScan"
                                    >
                                        {{ $t('Cerrar') }}
                                    </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </div>
                    </template>
                    <!-- end add barcode -->

                    <v-row>
                        <v-col cols="12" sm="6" :md="(typeStore=='product' || typeStore=='product_without_store') ? '5' : '7'">
                            <v-card>
                                <v-card-title>
                                    {{ $t('Elige los productos') }}
                                </v-card-title>
                                <v-card-title>
                                    <v-combobox
                                        :label="$t('Buscar producto (nombre, código)')"
                                        dense
                                        outlined
                                        hide-details
                                        :items="itemsProd"
                                        item-text="name_code"
                                        item-value="id"
                                        :return-object="true"
                                        v-model="resultProd"
                                        @update:search-input="searchProds($event)"
                                        @change="openDetails($event)"
                                    ></v-combobox>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        @click="startScan"
                                        color="primary"
                                        >
                                        <v-icon>mdi-barcode</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <!-- lista de productos -->
                                    <list-product-by-category @selected="openDetails" :money="money" :type-store="typeStore" />
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" :md="(typeStore=='product' || typeStore=='product_without_store') ? '7' : '5'">
                            <v-card>
                                <v-card-title>
                                    {{ $t('Resumen del pedido') }}
                                </v-card-title>
                                <v-card-text>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <v-chip
                                                            color="primary"
                                                            outlined
                                                        >
                                                            <strong>TOTAL</strong>
                                                        </v-chip>
                                                    </th>
                                                    <th colspan="3"></th>
                                                    <th><strong class="font-weight-black body-1">{{ tmpTotal }}</strong></th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    <th>
                                                        {{ $t('Código') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('Producto') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('Cantidad') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('Precio unitario') }}
                                                    </th>
                                                    <th v-if="typeStore=='product' || typeStore=='product_without_store'">
                                                        {{ $t('Descuento') }}
                                                    </th>
                                                    <th>
                                                        {{ $t('Subtotal') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(prod, i) in productList" :key="'index_'+i">
                                                    <td>
                                                        <v-btn
                                                            icon
                                                            color="error"
                                                            @click="productList.splice(i, 1), calculateTotal()"
                                                        >
                                                            <v-icon>
                                                                mdi-delete
                                                            </v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <td>{{ prod.code }}</td>
                                                    <td>{{ prod.name }} {{ prod.complements.multi.length>0 ? showComplementsMulti(prod.complements.multi) : '' }} {{ prod.complements.only.length>0 ? showComplementsOnly(prod.complements.only) : '' }}</td>
                                                    <td>
                                                        <span v-if="typeStore=='service'">{{ prod.quantity }}</span>
                                                        <v-text-field
                                                            v-model="productList[i].quantity"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            type="number"
                                                            min="0"
                                                            @input="calculateTotal()"
                                                            style="width: 100px;"
                                                            v-if="typeStore=='gastronomic' || typeStore=='product' || typeStore=='product_without_store'"
                                                        ></v-text-field>
                                                    </td>
                                                    <td>
                                                        <span v-if="typeStore=='service'">{{ prod.price }}</span>
                                                        <v-text-field
                                                            v-model="productList[i].price_normal"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            type="number"
                                                            min="0"
                                                            @input="calculateTotal()"
                                                            style="width: 100px;"
                                                            v-if="typeStore=='gastronomic' || typeStore=='product' || typeStore=='product_without_store'"
                                                        ></v-text-field>
                                                    </td>
                                                    <td v-if="typeStore=='product' || typeStore=='product_without_store'">
                                                        <v-text-field
                                                            v-model="productList[i].discount"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            type="number"
                                                            min="0"
                                                            @input="calculateTotal()"
                                                            style="width: 100px;"
                                                        ></v-text-field>
                                                    </td>
                                                    <td class="text-right">
                                                        <v-text-field
                                                            v-model="productList[i].price"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            type="number"
                                                            min="0"
                                                            @input="calculateTotal()"
                                                            style="width: 100px;"
                                                            v-if="typeStore=='service'"
                                                        ></v-text-field>
                                                        <span v-if="typeStore=='gastronomic' || typeStore=='product' || typeStore=='product_without_store'">{{ prod.price }}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot v-if="typeStore=='product' || typeStore=='product_without_store'">
                                                <tr>
                                                    <td colspan="6" class="text-right">
                                                        <strong>Subtotal</strong>
                                                    </td>
                                                    <td class="text-right">{{ tmpTotal }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="6" class="text-right">
                                                        <strong>{{ $t('Descuento general') }}</strong>
                                                    </td>
                                                    <td class="text-right">
                                                        <v-text-field
                                                            v-model="tmpDiscount"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            type="number"
                                                            min="0"
                                                            @input="calculateTotal()"
                                                            style="width: 100px;"
                                                            class="text-right"
                                                        ></v-text-field>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="6" class="text-right">
                                                        <strong>{{ $t('TOTAL') }}</strong>
                                                    </td>
                                                    <td class="text-right">{{ tmpTotal - tmpDiscount }}</td>
                                                </tr>
                                            </tfoot>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogSale = false"
                        :disabled="loading"
                    >
                        {{ $t('Cancelar') }}
                    </v-btn>
                    <v-btn
                        color="primary"
                        type="submit"
                        :loading="loading"
                        @click="showOptionPrint = false"
                    >
                        {{ $t('Registrar venta') }}
                    </v-btn>
                    <v-btn
                        color="primary"
                        type="submit"
                        :loading="loading"
                        @click="showOptionPrint = true"
                    >
                        {{ $t('Registrar e imprimir') }}
                    </v-btn>
                    <v-btn
                        color="secondary"
                        outlined
                        :disabled="loading"
                        v-if="hasQuotes"
                        @click="openQuoteDialog"
                    >
                        {{ $t('Cotizar') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>

    <!-- dialog -->
    <v-dialog
        v-model="dialogProd"
        width="500"
        scrollable
        :fullscreen="$vuetify.breakpoint.smAndDown"
        transition="dialog-bottom-transition"
        persistent
    >
        <v-skeleton-loader
            v-if="loadProd"
            class="white"
            type="card-avatar, article, actions"
        ></v-skeleton-loader>
        <v-card
            v-else
            class="mx-auto"
        >
            <v-overlay
                absolute
                :value="overlayProd"
                opacity=".8"
            >
                <v-progress-circular
                    indeterminate
                    size="64"
                    color="success"
                ></v-progress-circular>
            </v-overlay>
            <v-fab-transition>
                <v-btn
                    absolute
                    right
                    fab
                    small
                    style="top: 10px;"
                    @click="dialogProd=!dialogProd, loadProd=!loadProd, resultProd=''"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-fab-transition>

            <v-card-text class="pb-5 px-0">
                <v-card-title class="pa-0">
                    <v-carousel
                        height="auto"
                        class="simple-carousel"
                        :show-arrows="(galleryProd.length<=0)?false:true"
                        hide-delimiters
                        style="min-height: 250px;"
                        v-if="bannerProd != 'none'"
                    >
                        <v-carousel-item
                            class="white"
                            contain
                        >
                            <v-img
                                :src="bannerProd"
                                :lazy-src="bannerProd"
                            >
                                <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                        ></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-carousel-item>
                        <v-carousel-item
                            v-for="(img, j) in galleryProd" :key="j"
                            class="white"
                            contain
                        >
                            <v-img
                                :src="img.img"
                                :lazy-src="img.img"
                            >
                                <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                        ></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-carousel-item>
                    </v-carousel>
                    <div class="px-4 py-2" style="width:100%">
                        {{ nameProd }}
                    </div>

                </v-card-title>

                <div class="px-5 mb-5" v-if="descriptionProd" :style="{'fontSize':'16px'}" v-html="descriptionProd"></div>

                <template v-for="(row, j) in optionsProd">
                    <v-card-title class="py-3">
                        {{ row.title }}
                    </v-card-title>
                    <v-alert
                        :key="j+1*150"
                        dense
                        tile
                        outlined
                        type="error"
                        v-if="showAlertRequired && row.isRequired"
                    >{{ $t('Debe seleccionar una opción para continuar') }}</v-alert>
                    <!-- multiple -->
                    <v-list :key="j+10" v-if="row.type == 'multiple'">
                        <!-- select quantity -->
                        <template dense>
                            <v-list-item v-for="(opt) in row.values" :key="opt.name">
                                <v-list-item-content>
                                    <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                    <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                </v-list-item-content>

                                <div class="d-flex align-center mr-3" v-if="row.ifQuantity">
                                    <v-btn
                                        small
                                        :disabled="opt.quantity<=0"
                                        @click="changeQtyMultiple(row, opt, -1)"
                                    >
                                        <v-icon dark>
                                            mdi-minus
                                        </v-icon>
                                    </v-btn>
                                    <v-sheet
                                        height="28"
                                        width="60"
                                        class="sheet-cant"
                                    >
                                        {{ opt.quantity }}
                                    </v-sheet>
                                    <v-btn
                                        small
                                        :disabled="(opt.quantity<=0 && (row.tmpVal).length >= row.select) || (row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) >= row.selectQuantity)"
                                        @click="changeQtyMultiple(row, opt, 1)"
                                    >
                                        <v-icon dark>
                                            mdi-plus
                                        </v-icon>
                                    </v-btn>
                                </div>

                                <span :id="`${opt.name.replace(' ', '-')}_${opt.price}`" :data-details="`${opt.name}:${(row.quantities)?(opt.price*quantity):opt.price}:${opt.quantity}`"></span>

                                <!-- con cantidad, la selección se hace con +/- (cantidad > 0 = seleccionado) -->
                                <v-list-item-action v-if="!row.ifQuantity">
                                    <v-checkbox
                                        v-model="row.tmpVal"
                                        :value="`${opt.name.replace(' ', '-')}_${opt.price}`"
                                        color="primary"
                                        :disabled=" ((row.tmpVal).includes(`${opt.name.replace(' ', '-')}_${opt.price}`)) ? false : ((row.tmpVal).length >= row.select) "
                                        @change="changeRespMultiple"
                                    ></v-checkbox>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-list>
                    <!-- multiple end -->
                    <!-- only -->
                    <v-list :key="j+20" v-if="row.type == 'only'">
                        <v-list-item-group
                            v-model="row.tmpValOnly"
                            active-class=""
                            @change="changeRespOnly"
                        >
                        <v-list-item v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+((row.quantities)?(opt.price*quantity):opt.price)">
                            <template v-slot:default="{ active }">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                        <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-icon color="primary" v-if="active">
                                            mdi-circle-slice-8
                                        </v-icon>
                                        <v-icon v-else>
                                            mdi-checkbox-blank-circle-outline
                                        </v-icon>
                                    </v-list-item-action>
                                </template>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                    <!-- only end -->
                </template>

                <v-divider></v-divider>

                <div class="px-3 pt-5">
                    <v-textarea
                        outlined
                        :placeholder="$t('Dato extra')"
                        color="primary"
                        rows="3"
                        v-model="dataExtra"
                    ></v-textarea>
                </div>

            </v-card-text>

            <v-card-actions class="pa-actions">
                <!-- product -->
                <v-row no-gutters align="center" v-if="typeProd=='product'">
                    <v-col cols="6">
                        <div class="d-flex align-center">
                            <v-btn icon small @click="changePlusAndMinus('minus')" :disabled="quantity<=1">
                                <v-icon dark>
                                    mdi-minus
                                </v-icon>
                            </v-btn>
                            <v-text-field
                                placeholder="Cantidad"
                                color="primary"
                                outlined
                                dense
                                type="number"
                                min="1"
                                step="1"
                                :max="stock"
                                hide-details
                                v-model="quantity"
                                style="width:100px;max-width:100px;"
                                @input="changeQuantity($event)"
                            ></v-text-field>
                            <v-btn icon small @click="changePlusAndMinus('plus')" :disabled="quantity>=stock">
                                <v-icon dark>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <template>
                            <v-btn
                                large
                                block
                                rounded
                                color="primary"
                                @click="addToCart"
                                class="text-capitalize"
                            >
                                <strong>{{ $t('Agregar') }} {{ money }} {{ (quantity * price) + respMultipleVal + respOnlyVal }}</strong>
                            </v-btn>
                        </template>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- end dialog -->

    <!-- dialog cash -->
    <v-dialog
        v-model="dialogPrint"
        persistent
        max-width="350"
    >
        <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
                <v-btn
                    color="primary"
                    block
                    x-large
                    target="_blank"
                    class="mb-4"
                    :href="`/admin/print-internalsale/r/${internalSaleId}`"
                >{{ $t('Imprimir Recibo') }}</v-btn>
                <v-btn
                    color="primary"
                    block
                    x-large
                    target="_blank"
                    :href="`/admin/print-internalsale/c/${internalSaleId}`"
                >{{ $t('Imprimir Comanda') }}</v-btn>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    text
                    @click="dialogPrint = false"
                >
                    {{ $t('Cerrar') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- END dialog cash -->

    <!-- dialog nombre cotizacion -->
    <v-dialog
        v-model="dialogQuoteName"
        persistent
        max-width="450"
    >
        <v-form @submit.prevent="onSubmitQuote" ref="formQuote" lazy-validation>
            <v-card :loading="loadingQuote" :disabled="loadingQuote">
                <v-card-title class="text-h5 grey lighten-2">
                    {{ $t('Cotizar venta') }}
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-text-field
                        :label="$t('Nombre cliente *')"
                        dense
                        outlined
                        v-model="form.client"
                        :rules="[rules.required]"
                    ></v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogQuoteName = false"
                        :disabled="loadingQuote"
                    >
                        {{ $t('Cancelar') }}
                    </v-btn>
                    <v-btn
                        color="primary"
                        type="submit"
                        :loading="loadingQuote"
                    >
                        {{ $t('Generar cotización') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
    <!-- end dialog nombre cotizacion -->

    <!-- dialog print cotizacion -->
    <v-dialog
        v-model="dialogQuotePrint"
        persistent
        max-width="350"
    >
        <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
                <v-btn
                    color="primary"
                    block
                    x-large
                    target="_blank"
                    :href="`/admin/print-quote/${quoteId}`"
                >{{ $t('Imprimir cotización') }}</v-btn>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    text
                    @click="dialogQuotePrint = false"
                >
                    {{ $t('Cerrar') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- END dialog print cotizacion -->
    </div>
</template>

<script>
export default {
    data: () => ({
        dialogSale: false,
        itemsProd: [],
        resultProd: '',
        form: {
            credit: 0,
            days: '',
            fast: 1,
            client: '',
            nit: '',
            invoice: 0,
            phone: '',
            table_number: null,
            products: [],
            total: 0,
            payment: 'Efectivo',
            comment_order: ''
        },
        loading: false,
        /**prod */
        overlayProd: false,
        loadProd: true,
        dialogProd: false,
        prodId: '',
        bannerProd: '',
        galleryProd: [],
        nameProd: '',
        codeProd: '',
        typeProd: '',
        descriptionProd: '',
        optionsProd: [],
        quantity: 1,
        price: null,
        priceNormal: null,
        stock: 500,
        dataExtra: '',
        respMultiple: [],
        respMultipleVal: 0,
        respOnly: [],
        respOnlyVal: 0,
        showRequired: false,
        showAlertRequired: false,
        money: 'Bs.',
        productList: [],
        tmpTotal: 0,
        tmpDiscount: 0,
        cashReceived: '',
        _cashInsufficientNotifyTimer: null,
        rules: {
            required: value => !!value || 'Requerido.'
        },
        dialog: false,
        lastScanTime: 0,
        scanDelay: 2000,
        // imprimir
        showOptionPrint: false,
        dialogPrint: false,
        internalSaleId: '',
        // cotizacion
        dialogQuoteName: false,
        loadingQuote: false,
        dialogQuotePrint: false,
        quoteId: ''
    }),
    props:['slug', 'typeStore', 'hasQuotes'],
    computed: {
        isCashPayment() {
            const p = this.form.payment
            return p === this.$t('Efectivo') || p === 'Efectivo'
        },
        netAmountDue() {
            const gross =
                parseFloat(String(this.tmpTotal).replace(',', '.')) || 0
            const disc =
                parseFloat(String(this.tmpDiscount).replace(',', '.')) || 0
            const net = gross - disc
            return Math.round(net * 100) / 100
        },
        netAmountDueFormatted() {
            return this.netAmountDue.toFixed(2)
        },
        cashChange() {
            const total = this.netAmountDue
            const raw = this.cashReceived
            if (raw === '' || raw === null || raw === undefined) {
                return 0
            }
            const paid = parseFloat(String(raw).replace(',', '.'))
            if (Number.isNaN(paid)) {
                return 0
            }
            const diff = paid - total
            return diff > 0 ? Math.round(diff * 100) / 100 : 0
        },
        cashChangeFormatted() {
            return `${this.money} ${this.cashChange.toFixed(2)}`
        },
        cashPaymentInsufficient() {
            if (!this.isCashPayment || this.netAmountDue <= 0) {
                return false
            }
            const raw = this.cashReceived
            if (raw === '' || raw === null || raw === undefined) {
                return true
            }
            const paid = parseFloat(String(raw).replace(',', '.'))
            if (Number.isNaN(paid)) {
                return true
            }
            return paid + 1e-9 < this.netAmountDue
        },
    },
    watch: {
        dialogSale(val) {
            if (val) {
                this.cashReceived = ''
                this.clearCashInsufficientNotifyTimer()
            }
        },
        'form.payment'(val) {
            const cash =
                val === this.$t('Efectivo') || val === 'Efectivo'
            if (!cash) {
                this.cashReceived = ''
            }
        },
    },
    beforeDestroy() {
        this.clearCashInsufficientNotifyTimer()
    },
    methods: {
        clearCashInsufficientNotifyTimer() {
            if (this._cashInsufficientNotifyTimer) {
                clearTimeout(this._cashInsufficientNotifyTimer)
                this._cashInsufficientNotifyTimer = null
            }
        },
        notifyCashPaymentMustCoverTotal() {
            this.$notify.warning(
                this.$t('El pago en efectivo debe cubrir el total de la venta.')
            )
        },
        async searchProds(e) {
            if (typeof e == 'string') {
                await axios.get('/admin/prods-search?q=' + e + '&store=' + this.slug)
                .then((response) => {
                    // console.log(response);
                    this.itemsProd = response.data
                })
                .catch((error) => {
                    console.log(error);
                })
            }
        },
        changeQtyMultiple(row, opt, step) {
            const key = `${opt.name.replace(' ', '-')}_${opt.price}`
            const newQty = Math.max(0, opt.quantity + step)
            // respetar la cantidad máxima de todos los complementos juntos
            if (step > 0 && row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) + step > row.selectQuantity) return
            const isSelected = row.tmpVal.includes(key)

            if (newQty > 0 && !isSelected) {
                // respetar el máximo de opciones permitidas
                if (row.tmpVal.length >= row.select) return
                row.tmpVal.push(key)
            }
            if (newQty == 0 && isSelected) {
                row.tmpVal.splice(row.tmpVal.indexOf(key), 1)
            }

            opt.quantity = newQty
            this.changeRespMultiple()
        },
        changeRespMultiple() {
            this.verifyRequireds()
            setTimeout(() => {
                var tmpListComplements = []
                this.optionsProd.forEach(element => {
                    element.tmpVal.forEach(val => {
                        const selectedId = document.getElementById(val)
                        const dataSelected = selectedId.getAttribute('data-details')
                        tmpListComplements.push(dataSelected)
                    });
                });
                // console.log(tmpListComplements);
                this.respMultipleVal = 0
                if (tmpListComplements.length > 0) {
                    tmpListComplements.forEach(el => {
                        // console.log(el);
                        let valSelected = el.split(':')
                        let tmpPrice = (+valSelected[1]) * (+valSelected[2])
                        this.respMultipleVal += tmpPrice
                    });
                }
                this.respMultiple = tmpListComplements
            }, 500);
        },
        changeRespOnly() {
            this.verifyRequireds()
            const tmpListOnly = []
            this.optionsProd.forEach(element => {
                if (element.tmpValOnly) {
                    tmpListOnly.push(element.tmpValOnly)
                }
            });

            this.respOnlyVal = 0
            if (tmpListOnly.length > 0) {
                tmpListOnly.forEach(el => {
                    let tmpPrice = +(el.split(':')[1])
                    this.respOnlyVal += tmpPrice
                });
            }
            // console.log(tmpListOnly);
            this.respOnly = tmpListOnly
        },
        verifyRequireds() {
            for (let i = 0; i < this.optionsProd.length; i++) {
                const element = this.optionsProd[i];
                if (element.isRequired) {
                    if (element.type == 'multiple') this.showRequired = (element.tmpVal.length<=0)
                    if (element.type == 'only') this.showRequired = (element.tmpValOnly==undefined)
                }
                if (this.showRequired) break
            }
        },
        openDetails(e) {
            const typeInput = typeof e == 'string' ? 'code' : 'id'

            const id = typeInput=='id' ? e.id : e
            this.loadProd = true
            this.optionsProd = []
            this.respMultipleVal = 0
            this.respOnlyVal = 0
            this.respMultiple = []
            this.respOnly = []
            // this.dialogProd = true
            axios.get(`/show-product/${id}?store=${this.slug}&type=${typeInput}`)
            .then((response) => {
                // console.log(response.data);
                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                this.nameProd = response.data.name
                this.codeProd = response.data.code??'-'
                this.typeProd = response.data.type
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpVal = JSON.parse(element.values)
                        var multiRequired = []
                        var onlyRequired = undefined
                        tmpVal.forEach(val => {
                            // multiple con cantidad empieza en 0 (no seleccionado)
                            val.quantity = (element.type == 'multiple' && element.quantity) ? 0 : 1
                        });
                        if (element.type == 'multiple') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    val.quantity = 1
                                    // multiRequired.push(`${val.name}:${val.price}:${val.quantity}`)
                                    multiRequired.push(`${val.name.replace(' ', '-')}_${val.price}`)
                                    setTimeout(() => {
                                        this.changeRespMultiple()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        if (element.type == 'only') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    onlyRequired = val.name+':'+val.price
                                    setTimeout(() => {
                                        this.changeRespOnly()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        // const selectRequired = `${opt.name.replace(' ', '-')}_${opt.price}`
                        this.optionsProd.push({
                            title: element.title,
                            type: element.type,
                            values: tmpVal,
                            select: element.select,
                            selectQuantity: (+element.select_quantity > 0) ? +element.select_quantity : null,
                            tmpVal: multiRequired,
                            tmpValOnly: onlyRequired,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false,
                            quantities: (element.quantities)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price
                this.priceNormal = response.data.price??0;
                this.quantity = 1
                if (response.data.stock > 0) {
                    this.stock = response.data.stock
                }

                switch (this.typeStore) {
                    case 'product':
                        setTimeout(() => {
                            this.addToCart()
                        }, 300);
                        break;

                    case 'product_without_store':
                        setTimeout(() => {
                            this.addToCart()
                        }, 300);
                        break;

                    default:
                        this.dialogProd = true
                        setTimeout(() => {
                            this.loadProd = false
                        }, 800);
                        break;
                }

            })
            .catch((error) => {
                console.log(error);
            })
        },
        changeQuantity(event) {
            if (+event <= 1) {
                this.quantity = 1
            }
            if (+event > this.stock) {
                this.$fire({
                    title: this.$t('Agotado'),
                    text: this.$t(`Stock agotado, solo queda ${this.stock} productos en almacén`),
                    type: 'error',
                    confirmButtonText: this.$t('Entendido'),
                    confirmButtonColor: this.btnColor,
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(resp => {
                    if (resp.value) {
                        this.quantity = this.stock
                    }
                })
            }
        },
        updateQuantitysComplements() {
            this.optionsProd.forEach(element => {
                if (element.quantities) {
                    if (element.tmpValOnly) {
                        let tmp = element.tmpValOnly.split(':')
                        element.values.forEach(item => {
                            if (item.name == tmp[0]) tmp[1] = item.price
                        });
                        tmp[1] = tmp[1]*this.quantity
                        element.tmpValOnly = tmp.join(':')
                    }
                    if (element.tmpVal.length > 0) {
                        element.tmpVal.forEach(val => {
                            const selectedId = document.getElementById(val)
                            const dataSelected = selectedId.getAttribute('data-details')
                            let tmp2 = dataSelected.split(':')
                            element.values.forEach(item => {
                                if (item.name == tmp2[0]) tmp2[1] = item.price
                            });
                            tmp2[1] = tmp2[1]*this.quantity
                            selectedId.setAttribute('data-details', tmp2.join(':'))
                        });
                    }
                }
            });
            this.changeRespOnly()
            this.changeRespMultiple()
        },
        changePlusAndMinus(type) {
            var tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.price) * ((+this.quantity)-1))
                    if (tmpImport < 0) {
                        this.$notify.error(this.$t('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.'))
                        return
                    }
                    this.quantity = (+this.quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.price) * ((+this.quantity)+1))
                    if (tmpImport < 0) {
                        this.$notify.error(this.$t('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.'))
                        return
                    }
                    this.quantity = (+this.quantity) + 1
                    break
                default:
                    break
            }

            this.updateQuantitysComplements()

            this.changeQuantity(this.quantity)
        },
        addToCart() {
            this.showAlertRequired = false
            if (this.showRequired) {
                this.showAlertRequired = true
                return
            }
            this.overlayProd = true

            const priceNormal = this.price + this.respMultipleVal + this.respOnlyVal;

            const cart = {
                    prodId: this.prodId,
                    code: this.codeProd,
                    name: this.nameProd,
                    // price: this.price,
                    price_normal: priceNormal,
                    price: (this.quantity * priceNormal),
                    priceNormal: priceNormal,
                    quantity: this.quantity,
                    discount: 0,
                    extra: this.dataExtra,
                    complements: {
                        multi: this.respMultiple,
                        only: this.respOnly
                    }
                }

            console.log(cart);
            this.productList.push(cart)

            setTimeout(() => {
                this.overlayProd = false
                this.dialogProd = false
            }, 300);
            setTimeout(() => {
                this.$notify.success(this.$t('Producto agregado correctamente.'));
                this.resultProd = ''
                this.itemsProd = []
                this.dataExtra = ''
                this.calculateTotal()
            }, 500);
        },

        showComplementsMulti(txt) {
            let result = ''
            let tmpTxt = []
            txt.forEach(el => {
                tmpTxt = el.split(':')
                result += (' '+tmpTxt[0]+'x'+tmpTxt[2])
            });
            return result
        },
        showComplementsOnly(txt) {
            let result = ''
            let tmpTxt = []
            txt.forEach(el => {
                tmpTxt = el.split(':')
                result += (' '+tmpTxt[0])
            })
            return result
        },
        calculateTotal() {
            this.tmpTotal = 0
            this.productList.forEach(element => {
                this.tmpTotal += (((+element.price_normal) * (+element.quantity)) - (+element.discount))
                element.price = (((+element.price_normal) * (+element.quantity)) - (+element.discount))
            })
            this.tmpTotal = this.tmpTotal.toFixed(2)
        },
        /**
         * submit
         */
        async onSubmit() {
            if (!this.$refs.formSale.validate() || this.productList.length === 0) {
                this.$notify.info(this.$t('Por favor complete todos los campos requeridos.'));
                return
            }
            
            this.loading = true
            this.form.products = this.productList
            this.form.total = this.tmpTotal
            this.form.gralDiscount = this.tmpDiscount

            await axios.post('/admin/internal-sale', this.form)
                .then((response) => {
                    // console.log(response);
                    if (response.data[0] === 'ok') {
                        this.$notify.success(this.$t('Venta registrada con exito.'));
                        this.form = {
                            credit: 0,
                            days: '',
                            fast: 0,
                            client: '',
                            nit: '',
                            invoice: 0,
                            phone: '',
                            table_number: null,
                            products: [],
                            total: 0,
                            payment: 'Efectivo',
                            comment_order: ''
                        }
                        this.productList = []
                        this.tmpTotal = 0
                        this.tmpDiscount = 0
                        this.cashReceived = ''
                        // this.$refs.formSale.reset()
                        this.dialogSale = false
                        if (this.showOptionPrint) {
                            this.internalSaleId = response.data[1]
                            if (this.typeStore == 'product' || this.typeStore=='product_without_store') {
                                window.open(`/admin/print-internalsale/r/${this.internalSaleId}`, '_blank');
                            } else {
                                window.open(`/admin/print-internalsale-complete/${this.internalSaleId}`, '_blank');
                                // this.dialogPrint = true
                            }
                        }
                    }
                    this.loading = false
                })
                .catch((error) => {
                    // console.log(error);
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                    }
                    this.loading = false
                })
        },
        /**
         * cotizacion
         */
        openQuoteDialog() {
            if (!this.$refs.formSale.validate() || this.productList.length === 0) {
                this.$notify.info(this.$t('Por favor complete todos los campos requeridos.'));
                return
            }
            this.dialogQuoteName = true
        },
        async onSubmitQuote() {
            if (!this.$refs.formQuote.validate()) {
                return
            }

            this.loadingQuote = true
            this.form.products = this.productList
            this.form.total = this.tmpTotal
            this.form.gralDiscount = this.tmpDiscount

            await axios.post('/admin/quote', this.form)
                .then((response) => {
                    if (response.data[0] === 'ok') {
                        this.$notify.success(this.$t('Cotización generada con exito.'));
                        this.form = {
                            credit: 0,
                            days: '',
                            fast: 0,
                            client: '',
                            nit: '',
                            invoice: 0,
                            phone: '',
                            table_number: null,
                            products: [],
                            total: 0,
                            payment: 'Efectivo',
                            comment_order: ''
                        }
                        this.productList = []
                        this.tmpTotal = 0
                        this.tmpDiscount = 0
                        this.cashReceived = ''
                        this.quoteId = response.data[1]
                        this.dialogQuoteName = false
                        this.dialogSale = false
                        this.dialogQuotePrint = true
                    }
                    this.loadingQuote = false
                })
                .catch((error) => {
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                    }
                    this.loadingQuote = false
                })
        },
        async onScan(decodedText, decodedResult) {
            const currentTime = new Date().getTime();
            if (currentTime - this.lastScanTime > this.scanDelay) {
                this.lastScanTime = currentTime;

                // console.log(decodedText);
                let res = await axios.get(`/admin/prods-search?q=${decodedText}`);

                if(res.data.length > 0) {
                    let res2 = await axios.get(`/show-product/${res.data[0].id}?store=${this.slug}`);

                    let {id,code,name,price} = res2.data;
                    const cart = {
                        prodId: id, code: code, name: name, price: price,
                        priceNormal: price, quantity: 1,
                        extra: [], complements: { multi: [], only: [] }
                    }

                    this.productList.push(cart);
                    setTimeout(() => {
                        this.overlayProd = false
                        this.dialogProd = false
                    }, 300);
                    setTimeout(() => {
                        this.$notify.success(this.$t('Producto agregado correctamente.'));
                        this.resultProd = ''
                        this.dataExtra = ''
                        this.calculateTotal()
                    }, 500);
                }

            }
        },
        startScan() {
            this.$refs.barcodeRef?.start();
            this.dialog = true;
        },
        stopScan () {
            this.$refs.barcodeRef.stop();
            this.dialog = false;
        }
    }
}
</script>
<style lang="scss">
.cash-change-field--active.v-input--is-readonly.v-text-field--outlined ::v-deep fieldset {
    border-color: var(--v-error-base, #f44336) !important;
    border-width: 2px;
}
</style>
